import Vue from 'vue';
import Router from 'vue-router';
import RedemptionPage from '@/views/RedemptionPage.vue';
import LoginPage from '@/views/login.vue';
import OffLinePage from '@/views/OffLinePage.vue';
import OffLineResult from '@/views/OffLineResult.vue';
import MyRedemption from '@/views/MyRedemption.vue';
import RedemptionList from '@/views/RedemptionList.vue';
import AudioVideoPage from '@/views/AudioVideoPage.vue';
import basePage from '@/views/basePage.vue';
import StripePage from '@/views/StripePage.vue';
import UserAgreement from '@/views/UserAgreement.vue';
import PrivacyPage from '@/views/PrivacyPage.vue';
import posterPage from '@/views/posterPage.vue';
import OffLineAgreement from '@/views/OffLineAgreement.vue';
import OffLineAgreementEn from '@/views/OffLineAgreementEn.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect:'/RedemptionPage', // RedemptionPage
  },
  {
    path: '/stripePage',
    name:'StripePage',
    component:StripePage,
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/RedemptionPage',
    name: 'RedemptionPage',
    component: RedemptionPage
  },
  {
    path: '/OffLinePage',
    name: 'OffLinePage',
    component: OffLinePage
  },
  {
    path: '/OffLineResult',
    name: 'OffLineResult',
    component: OffLineResult
  },
  {
    path: '/MyRedemption',
    name: 'MyRedemption',
    component: MyRedemption
  },
  {
    path: '/RedemptionList',
    name: 'RedemptionList',
    component: RedemptionList
  },
  {
    path: '/AudioVideoPage',
    name: 'AudioVideoPage',
    component: AudioVideoPage
  },
  {
    path: '/basePage',
    name: 'basePage',
    component: basePage
  }, 
  {
    path: '/UserAgreement',
    name: 'UserAgreement',
    component: UserAgreement
  },  
  {
    path: '/PrivacyPage',
    name: 'PrivacyPage',
    component: PrivacyPage
  }, 
  {
    path: '/posterPage',
    component: posterPage
  },
  {
    path: '/OffLineAgreement',
    name: 'OffLineAgreement',
    component: OffLineAgreement
  }, 
  {
    path: '/OffLineAgreementEn',
    name: 'OffLineAgreementEn',
    component: OffLineAgreementEn
  }, 
];

const router = new Router({
  mode: 'history',
  routes
});

export default router;
